<template>
    <div>
        <div class="switch-day">
          <!-- <div>
            <el-button type="primary">上一天</el-button>
          </div>
          <div>2023-10-10</div>
          <div>
            <el-button type="primary">上一天</el-button>
          </div> -->
          <el-date-picker
            v-model="currDate"
            type="date"
            @change="dateChange"
            placeholder="选择日期">
          </el-date-picker>
        </div>
        <div class="bar-mark">
          <div class="bar-mark-item" v-for="(item, index) in barColorList" :key="index">
            <div class="bar-mark-color" :style="{'background-color': item.color}"></div>
            <div class="bar-mark-name">{{item.name}}</div>
          </div>
        </div>
        <div ref="timeAxisRef" class="time-scroll">
          <div class="audio-icon">
            <i class="el-icon-video-play" v-if="!currAudioUrl" @click="playAudio(currItemIndex)"></i>
            <i class="el-icon-video-pause" v-if="!!currAudioUrl" @click="pauseAudio()"></i>
          </div>
          <div class="time-axis">
            <div class="time-axis-item" v-for="(item, index) in deviceAudioData" :key="item.monitor_end">
              <div 
              class="item-bar" 
              :style="{width: `${timeNumConfig.itemWidth}px`, 'background-color': barColorList[item.type].color}" 
              :title="`${item.scale_start_text}-${item.scale_end_text}`"
              @click="playAudio(index)"
              >
                <div class="item-scale" v-if="item.monitor_start%(timeNumConfig.scaleInterval*60*1000)===0">{{item.scale_start_text}}</div>
              </div>
            </div>
          </div>
          <div class="time-vernier" :style="vernierStyle"></div>
        </div>
        <sh-audio v-if="!!currAudioUrl" :url="currAudioUrl" @play="audioPlayCb" @ended="audioEndCb"></sh-audio>
    </div>
</template>

<script>
import { Message } from 'element-ui'
import moment from '@/libs/moment'
import { getDeviceAudioApi, getAudioUrlApi } from '@/api/user'
import ShAudio from '@/components/Audio'

export default {
    name: 'DevicesAudio',
    components: {
        ShAudio
    },
    props: {
        id: Number,
        // henneryId: Number
    },
    data () {
        return {
            currDate: '',
            deviceAudioParams: {
                start_time: null,
                end_time: null,
                device_id: null,
                limit: 10000
            },
            deviceAudioData: [],
            oneDayTime: 24 * 60 * 60 * 1000,
            itemTime: 5*60*1000,
            timeNumConfig: {
                itemWidth: 5,  // 一条数据的宽度（目前5分钟一条数据）
                scaleInterval: 120  // 多少分钟一个刻度
            },
            barColorList: [
                {
                    name: '无数据',
                    color: '#999'
                }, 
                {
                    name: '健康',
                    color: 'green'
                },
                {
                    name: '无鸡叫',
                    color: 'white'
                },
                {
                    name: '不健康',
                    color: 'red'
                },
                {
                    name: '不确定',
                    color: 'orange'
                }
            ],
            currAudioUrlList: [],
            currAudioUrl: '',
            currAudioCount: 0,
            currAudioIndex: 0,
            currItemIndex: 0,
            vernierStyle: {
              'left': '50px',
              'transition-duration': '0s',
            }
        }
    },
    computed: {

    },
    methods: {
        dateChange (e) {
            if(e) {
                this.currAudioIndex = 0
                this.currAudioUrl = ''
                this.currItemIndex = 0
                this.vernierStyle.left = '50px'
                this.setTransitionDuration(0)
                this.deviceAudioParams.start_time = moment(e).valueOf()
                this.deviceAudioParams.end_time = this.deviceAudioParams.start_time + this.oneDayTime
                this.getDeviceAudio()
            }
        },
        initAudio () {

        },
        getDeviceAudio () {
            getDeviceAudioApi(this.deviceAudioParams).then(res=>{
                this.deviceAudioData = []
                const data = res.data.data.reverse()
                // 5分钟一条数据，类型为：不健康、健康、无鸡叫  2023-10-27 12:40:00之后是2分钟一条数据
                // this.deviceAudioData.forEach((item) => {
                //   let audios = item.audios
                //   item.type = 2
                //   item.scale_text = moment(item.monitor_end).format('HH:mm:ss')
                //   item.scale_start_text = moment(item.monitor_start).format('YYYY-MM-DD HH:mm:ss')
                //   /**
                //    * audios数组内只返回 不健康、健康、无鸡叫（也是优先级顺序，即5分钟内只要有不健康的鸡叫即为不健康，内有健康和无鸡叫即为健康，都是无鸡叫则为无鸡叫）
                //    */
                //   if(audios.length > 0 && ((audios[0].remark_type===-2 && audios[0].audio_type===0) || audios[0].remark_type===0)) {
                //     item.type = 1
                //   }
                // })
                let arr = []
                // let itemTime = 5*60*1000
                // console.log(this.deviceAudioParams.start_time)
                // console.log(this.deviceAudioParams.end_time)
                for(let i=this.deviceAudioParams.start_time; i<this.deviceAudioParams.end_time; i+=this.itemTime) {
                    // console.log(i, i+this.itemTime)
                    let obj = {
                        type: 0,
                        monitor_start: i,
                        monitor_end: i+this.itemTime,
                        scale_start_text: moment(i).format('HH:mm:ss'),
                        scale_end_text: moment(i+this.itemTime).format('HH:mm:ss')
                    }
                    for(let j=0; j<data.length; j++) {
                        let item = data[j]
                        if(i === item.monitor_start) {
                            let audios = item.audios
                            obj.audios = audios
                            // audio_type 0:健康 -1：无鸡叫 -10：不确定 1：不健康
                            // if(audios[0].remark_type===-2) {
                                if(audios[0].audio_type === 0) {
                                    obj.type = 1
                                } else if(audios[0].audio_type === -1) {
                                    obj.type = 2
                                } else if(audios[0].audio_type === -10) {
                                    obj.type = 4
                                } else if(audios[0].audio_type === 1) {
                                    obj.type = 3
                                }
                            // } else {
                            //     if(audios[0].remark_type === 0) {
                            //         obj.type = 1
                            //     } else if(audios[0].remark_type === -1) {
                            //         obj.type = 2
                            //     } else {
                            //         obj.type = 3
                            //     }
                            // }
                            break
                        }
                    }
                    this.deviceAudioData.push(obj)
                }
                console.log('deviceAudioData', this.deviceAudioData)
                this.$refs.timeAxisRef.scrollTo({left: 0, behavior: 'smooth'})
                // this.deviceAudioData.forEach(item => {
                //   let audios = item.audios
                //   item.type = 0
                //   item.scale_text = moment(item.monitor_end).format('HH:mm:ss')
                //   item.scale_start_text = moment(item.monitor_start).format('YYYY-MM-DD HH:mm:ss')
                //   if(!!audios && audios.length > 0) {
                //     if(audios[0].remark_type===-2) {
                //       if(audios[0].audio_type === 0) {
                //         item.type = 1
                //       } else if(audios[0].audio_type === -1) {
                //         item.type = 2
                //       } else {
                //         item.type = 3
                //       }
                //     } else {
                //       if(audios[0].remark_type === 0) {
                //         item.type = 1
                //       } else if(audios[0].remark_type === -1) {
                //         item.type = 2
                //       } else {
                //         item.type = 3
                //       }
                //     }
                //   }
                // })
            })
        },
        playAudio (index) {
          if(this.oneDayTime/this.itemTime < (index+1)) {
            Message.info('已播放完')
            return
          }
          let item = this.deviceAudioData[index]
          this.currItemIndex = index
          this.setTransitionDuration(0)
          this.vernierStyle.left = 50 + (this.timeNumConfig.itemWidth * index) + 'px'
          if(!item.audios || (item.audios && item.audios.length<=0)) {
              Message.info(item.scale_start_text + '-' + item.scale_end_text + ' 没有音频文件')
              // this.playAudio(this.currItemIndex + 1)
              return
          }
          this.currAudioUrlList = item.audios
          this.currAudioCount = this.currAudioUrlList.length
          // await this.getAudioUrl(this.currAudioUrlList[this.currAudioIndex].id)
          this.currAudioUrl = this.currAudioUrlList[this.currAudioIndex].audio_path
        },
        pauseAudio () {
          this.currAudioIndex = 0
          this.currAudioUrl = ''
          this.setTransitionDuration(0)
          this.vernierStyle.left = 50 + (this.timeNumConfig.itemWidth * this.currItemIndex) + 'px'
        },
        audioPlayCb () {
          if(this.currAudioIndex === 0) {
            this.setTransitionDuration(this.currAudioUrlList.length * 5)
            this.vernierStyle.left = 50 + (this.timeNumConfig.itemWidth * (this.currItemIndex + 1)) + 'px'
          }
        },
        async audioEndCb (cb) {
            if(this.currAudioCount > (this.currAudioIndex + 1)) {
                this.currAudioIndex++
                await this.getAudioUrl(this.currAudioUrlList[this.currAudioIndex].id)
                // this.currAudioUrl = this.currAudioUrlList[this.currAudioIndex].audio_path
            } else {
                this.currAudioIndex = 0
                this.currAudioUrl = ''
                this.playAudio(this.currItemIndex + 1)
            }
        },
        setTransitionDuration (time) {
          this.vernierStyle['transition-duration'] = time + 's'
          this.vernierStyle['-webkit-transition-duration'] = time + 's'
          this.vernierStyle['-moz-transition-duration'] = time + 's'
          this.vernierStyle['-o-transition-duration'] = time + 's'
        },
        /**
         * isSick 1:sick
         */
        // async getAudioUrl (id) {
        //   await getAudioUrlApi(id, {hennery_id: this.henneryId, is_sick_path: 0}).then(res=>{
        //     console.log('URL', res.data)
        //     this.currAudioUrl = res.data.data.link
        //     // cb(res.data.data.link)
        //   }).catch(() => {
        //     Message.error('获取音频URL失败')
        //   })
        // },
    },
    created () {
        this.currDate = moment().format('YYYY-MM-DD')
        this.deviceAudioParams.start_time = moment(this.currDate).valueOf()
        this.deviceAudioParams.end_time = this.deviceAudioParams.start_time + this.oneDayTime
        this.deviceAudioParams.device_id = this.id
        this.getDeviceAudio()
    },
    mounted () {
        
    },
    beforeDestroy () {
        // console.log(1)
        // this.$destroy()
        this.currAudioIndex = 0
        this.currAudioUrl = ''
    },
    destroyed () {
        // console.log(2)
        // this.deviceAudioData= []
    },
    watch: {

    }
}
</script>

<style lang="scss" scoped>
.switch-day {
  // display: flex;
  // justify-content: space-between;
  // align-items: center;
  text-align: center;
  padding: 20px 0;
}
.bar-mark {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 20px;
  .bar-mark-item {
    display: flex;
    // justify-content: center;
    align-items: center;
    padding: 0 15px;
    .bar-mark-color {
      width: 30px;
      height: 15px;
      margin-right: 2px;
    }
    .bar-mark-name {
      color: #aab6e4;
    }
  }
}
.time-scroll {
  overflow: auto;
  position: relative;
  .audio-icon {
    position: absolute;
    width: 100%;
    top: 10px;
    font-size: 56px;
    text-align: center;
    color: #017dfa;
    cursor: pointer;
  }
  .time-axis {
    // display: flex;
    white-space: nowrap;
    padding: 100px 50px;
    .time-axis-item {
      display: inline-block;
      .item-bar {
        width: 5px;
        height: 30px;
        background-color: gray;
        position: relative;
        cursor: pointer;
        &:hover {
          opacity: 0.8;
        }
        .item-scale {
          width: 100px;
          text-align: center;
          position: absolute;
          right: -45px;
          top: 30px;
          // background-color: blue;
          &::after {
            content: '';
            display: inline-block;
            width: 1px;
            height: 5px;
            background-color: #ffffff;
            position: absolute;
            left: 50px;
            top: 0;
          }
        }
      }
    }
  }
  .time-vernier {
    position: absolute;
    left: 50px;
    bottom: 0;
    width: 1px;
    height: 142px;
    background-color: rgba(90,167,254,0.7);
    transition: left 0s linear 0s;
    -webkit-transition: left 0s linear 0s;
    -moz-transition: left 0s linear 0s;
    -o-transition: left 0s linear 0s;
    // transition-property: left;
    // transition-duration: 0s;
    // transition-timing-function: linear;
    // transition-delay: 0s;
  }
}
</style>
